module.exports = __webpack_public_path__ + "img/PICK_UP.a8dd1334.png";